import type { BuilderDaSimulacao } from '../../types';
import { buscarAgenteDaSimulacao } from './actions';

export function registrarAgenteDaSimulacao(builder: BuilderDaSimulacao): void {
  builder
    .addCase(buscarAgenteDaSimulacao.pending, (state, action) => {
      state.agente = {
        dados: null,
        carregando: true,
        erro: null,
        requisicaoId: action.meta.requestId,
      };
    })
    .addCase(buscarAgenteDaSimulacao.fulfilled, (state, action) => {
      if (
        state.agente.requisicaoId !== action.meta.requestId ||
        state.formulario.flowId !== action.meta.arg
      )
        return;
      state.agente.dados = action.payload;
      state.agente.carregando = false;
      state.agente.requisicaoId = null;
    })
    .addCase(buscarAgenteDaSimulacao.rejected, (state, action) => {
      if (
        state.agente.requisicaoId !== action.meta.requestId ||
        state.formulario.flowId !== action.meta.arg
      )
        return;
      state.agente.carregando = false;
      state.agente.erro = action.payload?.mensagem ?? 'Erro ao carregar detalhes do agente';
      state.agente.requisicaoId = null;
    });
}
